export enum BookTopChartEnum {
  VIEW = 'VIEW',
  PURCHASE = 'PURCHASE',
}
